import SolutionsClinicians from "@/components/SolutionsClinicians";

export default function CliniciansPrimaryCare() {
  return (
    <div>
      <main>
        <SolutionsClinicians />
      </main>
    </div>
  );
}

